<template>
  <td>{{ html }}</td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['content'],
    computed: {
      html () {
        return this.content !== null ? this.content.slice(0, 60) : defaultNullHtml();
      }
    }
};
</script>
